export default __webpack_public_path__ + "static/media/doc-filter-arrow.dafb9675.svg";